import { render, staticRenderFns } from "./TakeawayPage.vue?vue&type=template&id=53907e18&scoped=true"
import script from "./TakeawayPage.vue?vue&type=script&lang=js"
export * from "./TakeawayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53907e18",
  null
  
)

export default component.exports